export default "__VITE_ASSET__DhRgi2UR__"